import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import AppearanceSettingsForm from "@/components/AppearanceSettingsForm";

/**
 * DisplaySettingsDialog — popup pengaturan tampilan per-user (2026-06-11).
 * Isi form diekstrak ke AppearanceSettingsForm (2026-06-13) supaya bisa
 * dipakai ulang di Settings → tab Tampilan.
 */
export default function DisplaySettingsDialog({ open, onOpenChange, prefs, onSaved }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-lg" data-testid="display-settings-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight">Pengaturan Tampilan</DialogTitle>
          <DialogDescription>
            Preferensi ini tersimpan per akun Anda dan berlaku di semua perangkat.
          </DialogDescription>
        </DialogHeader>
        <AppearanceSettingsForm
          prefs={prefs}
          onSaved={(merged) => { onSaved?.(merged); onOpenChange(false); }}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
